var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditbtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2573",
    "data-name": "Group 2573",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.173,
    height: 18.915,
    viewBox: "0 0 19.173 18.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_943",
    "data-name": "Rectangle 943",
    width: 19.173,
    height: 18.915,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2572",
    "data-name": "Group 2572",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M30.193,14.154q.078-.861.157-1.722c.029-.311.064-.622.091-.933a1.637,1.637,0,0,1,.531-1.033q4.188-4.19,8.372-8.386.67-.672,1.341-1.343a2.519,2.519,0,0,1,3.488-.07,11.3,11.3,0,0,1,.8.821,2.438,2.438,0,0,1-.048,3.256c-.28.3-.576.584-.866.875q-4.413,4.423-8.82,8.852a2.354,2.354,0,0,1-1.618.732c-.733.045-1.463.141-2.2.192a1.146,1.146,0,0,1-1.233-1.24m1.545-.2c.649-.061,1.3-.123,1.947-.182a.652.652,0,0,0,.447-.178q3.907-3.927,7.825-7.842c.121-.121.128-.194,0-.317-.61-.6-1.211-1.208-1.816-1.813-.191-.192-.192-.192-.385,0L34.313,9.1q-1.17,1.176-2.342,2.349a.4.4,0,0,0-.157.238q-.1,1.068-.2,2.137c-.009.094.024.149.128.135M44.174,3.094a.97.97,0,0,0-.294-.751c-.226-.236-.455-.469-.692-.693a1.039,1.039,0,0,0-1.4-.024c-.258.231-.494.489-.743.731-.078.076-.074.13,0,.206q.975.97,1.944,1.948c.1.1.153.077.236-.01.212-.221.433-.432.645-.652a1,1,0,0,0,.306-.754",
    transform: "translate(-28.176 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M9.609,262.511q4.388,0,8.776,0a.724.724,0,0,1,.727.421.688.688,0,0,1-.45.943,1.408,1.408,0,0,1-.372.038H.883a.977.977,0,0,1-.56-.125.676.676,0,0,1-.3-.739.707.707,0,0,1,.644-.534c.076,0,.153,0,.229,0H9.609",
    transform: "translate(0 -244.996)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditbtn);
export default __webpack_public_path__ + "static/media/icon_editbtn.a100c05b89c179484828b52e8777ff80.svg";
export { ForwardRef as ReactComponent };